import { render, staticRenderFns } from "./cjhw.vue?vue&type=template&id=8f2d1aaa&scoped=true&"
import script from "./cjhw.vue?vue&type=script&lang=js&"
export * from "./cjhw.vue?vue&type=script&lang=js&"
import style0 from "./cjhw.vue?vue&type=style&index=0&id=8f2d1aaa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2d1aaa",
  null
  
)

export default component.exports